module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMzgzMzQwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDcuNDQgNDA3LjQ0Ij48cGF0aCBkPSJNMjAzLjcyIDkxLjU3TDAgMjk0LjYybDIxLjE4IDIxLjI1IDE4Mi41NC0xODEuOTUgMTgyLjU0IDE4MS45NSAyMS4xOC0yMS4yNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/collapsable/chevron-flipped.svg
// module id = ./src/styles/collapsable/chevron-flipped.svg
// module chunks = 21